import { FC } from 'react';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';

import { NotFoundWrapper } from './CitySearch.styles';

export const NotFound: FC = () => {
    const { t } = useTranslations();

    return <NotFoundWrapper>{t['retails_map.search.not_found']}</NotFoundWrapper>;
};
